// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"a87c5d84","513":"50d35319","703":"3a315fbf","787":"292eae77"}[chunkId] + ".chunk.js";
};